import React from 'react';
import { StopCircle } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { track } from '@/analytics';

type Props = {
    onClick: () => void;
};

const AIStopButton = React.memo(({ onClick }: Props) => {
    const { t } = useTranslation();

    const handleClick = React.useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        e.stopPropagation();
        track('click-on-ai-popover-button', { button: 'stop' });
        onClick();
    }, [onClick]);

    return (
        <button
            type="button"
            onClick={handleClick}
            className="h-8 flex items-center justify-center space-x-1.5 px-2 py-1.5 rounded-md border border-saga-gray-200 dark:border-saga-gray-700 cursor-pointer bg-white dark:bg-saga-gray-900 hover:bg-saga-gray-100 dark:hover:bg-saga-gray-800 transition-colors"
        >
            <StopCircle size={14} />
            <div className="flex items-end justify-end space-x-1">
                <span className="font-normal text-sm dark:text-white">{t('common.stop')}</span>
                <span className="font-bold text-[8px] leading-4 text-saga-gray-500">ESC</span>
            </div>
        </button>
    );
});

AIStopButton.displayName = 'AIStopButton';

export default AIStopButton;
